<template>
    <div class="fun_container">
      <div class="top_jumbotron">
        <div class="container guidelink_area1">
          <a v-on:click="clickLink()" class="guidelinktxt1">
            <!-- Create+使い方ガイド -->
            <CreateplusMessage fcontId="0" flinkId="1" msgkey="12" />&nbsp;&raquo;
          </a>
        </div>
        <div class="top_imgontitle">
          <!-- Create+タイトル -->
          <img :src="app_root + '/assets/createplus/img/createplus_titlelogo.png'" alt="">
          <!-- <h1><CreateplusMessage fcontId="0" flinkId="1" msgkey="1" /></h1> -->
        </div>
        
       
      </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import CreateplusMessage from "./CreateplusMessage";
export default {
  name: "CreatePlusJumbotron",
  components: {
    CreateplusMessage,
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT,
    };
  },
  computed: {
    ...mapState(["lg2"]),
  },
  methods: {
    clickLink: function () {
      this.$gtag.event("tap_button", {
        "custom_parameter1": "create_guide"
      })
      this.$router.push({ 
        path: "/createplus/" + this.lg2 + "/templates/guide",
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale } 
      });
    }
  }
}
</script>

<style scoped>
</style>